import { render, staticRenderFns } from "./quotations.vue?vue&type=template&id=28b67276&scoped=true&"
import script from "./quotations.vue?vue&type=script&lang=js&"
export * from "./quotations.vue?vue&type=script&lang=js&"
import style0 from "./quotations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./quotations.vue?vue&type=style&index=1&id=28b67276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b67276",
  null
  
)

export default component.exports